import { render, staticRenderFns } from "./SignalStartEvent.vue?vue&type=template&id=c28c4aba&scoped=true&"
import script from "./SignalStartEvent.vue?vue&type=script&lang=js&"
export * from "./SignalStartEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c28c4aba",
  null
  
)

export default component.exports